var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('h2',[_vm._v("Abilities")]),_c('hr'),_c('ul',{staticClass:"mb-4"},_vm._l((_vm.data),function(skill,index){return _c('li',{key:index,staticClass:"caps"},[_vm._v(_vm._s(skill))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }